// extracted by mini-css-extract-plugin
export default {"container":"style_container__u2WTw","reviewContainer":"style_reviewContainer__AWVpI"};